import React from 'react';
import './Sub-services.css';
import mantenimiento from './assets/Mantenimiento.png';

const MantenimientoTanque = () => {
    return (
        <div className="containerSer">
            <h2>Mantenimiento de sistemas de calentamiento solar</h2>
            <p>
               El mantenimiento de los diferentes sistemas solares (fotovoltaicos y de calentamiento de agua) incluye el diagnóstico técnico, la verificación de componentes críticos y el ajuste de todas las partes del sistema para garantizar su correcto funcionamiento, prolongar su vida útil y maximizar el ahorro energético. Este proceso evita fallas inesperadas, pérdidas de energía y daños en la infraestructura que puedan afectar a los residentes o usuarios.
          </p>
            <img src={mantenimiento} alt="Imagen tanques solares y su mantenimiento" />
            <p>
                Ofrecemos servicio de mantenimiento profesional y personalizado para sistemas solares fotovoltaicos y calentadores solares. Este servicio incluye; revisión visual, limpieza de paneles y tanques solares, revisión de conexiones eléctricas, inversores, fusibles; control de niveles; estado del fluido térmico en calentadores, pruebas de funcionamiento, ajustes de protecciones; reemplazo preventivo de componentes, informe de hallazgos y recomendaciones.
            </p>
            <h3>Beneficios clave:</h3>
            <ul>
                <li>Máxima el rendimiento de los sistemas.</li>
                <li>Prevención de fallas y reducción de gastos inesperados.</li>
                <li>Mayor vida útil de los sistemas.</li>
                <li>Tranquilidad al dejar este proceso en manos de expertos.</li>
            </ul>

 
        </div>
    );
}

export default MantenimientoTanque;
